import React from "react";
import ContactHero from "../components/contact/ContactHero";
import ContactGrid from "../components/contact/ContactGrid";

const Contact = () => {
  return (
    <div className="w-full overflow-x-hidden">
      <ContactHero />
      <ContactGrid />
    </div>
  );
};

export default Contact;
